import { render } from "./ActionsDropdownItem.vue?vue&type=template&id=5da281b3&scoped=true"
import script from "./ActionsDropdownItem.vue?vue&type=script&lang=js"
export * from "./ActionsDropdownItem.vue?vue&type=script&lang=js"

import "./ActionsDropdownItem.vue?vue&type=style&index=0&id=5da281b3&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5da281b3"]])

export default __exports__